import Mapbox from 'index.vue';
import { BaseRasterLayer } from './baseRasterLayer';
export class GoogleMapsLayer extends BaseRasterLayer {
    constructor(mapboxInstance: InstanceType<typeof Mapbox>, satteliteView : boolean) {
        super(mapboxInstance, 'bottom'); 
        const tileUrl = `https://mt1.google.com/vt/lyrs=` + (!satteliteView ? 'm' : 's') + `&x={x}&y={y}&z={z}&key=AIzaSyCgUvP8k1S9aCis6D9GxDWmOawcImn_Sv4`;
        this.AddLayer('google', tileUrl, 25);
    }
}